import { useEffect, useState } from "react";
import type { Warehouse } from "../../data/schemaTypes";
import { useMastersStore } from "../../data/mastersStore";
import { Button, Input } from "../../components/ui";

type Props = {
  warehouse: Warehouse | null;
  onClose: () => void;
};

// Editor de almacén — campos básicos + coords. Lat/Lon como inputs simples;
// versiones futuras pueden abrir un picker en mapa.
export function WarehouseEditModal({ warehouse, onClose }: Props) {
  const updateWarehouse = useMastersStore((s) => s.updateWarehouse);

  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [lat, setLat] = useState("");
  const [lon, setLon] = useState("");
  const [active, setActive] = useState(true);

  useEffect(() => {
    if (!warehouse) return;
    setCode(warehouse.code);
    setName(warehouse.name);
    setAddress(warehouse.address ?? "");
    setLat(warehouse.lat?.toString() ?? "");
    setLon(warehouse.lon?.toString() ?? "");
    setActive(warehouse.active);
  }, [warehouse]);

  if (!warehouse) return null;

  function save() {
    if (!warehouse) return;
    updateWarehouse(warehouse.id, {
      code: code.trim(),
      name: name.trim(),
      address: address.trim() || undefined,
      lat: lat ? Number(lat) : undefined,
      lon: lon ? Number(lon) : undefined,
      active,
    });
    onClose();
  }

  return (
    <div
      className="fixed inset-0 z-[2000] bg-ink/50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        className="bg-card border border-border rounded-lg shadow-card-hover w-full max-w-md p-5"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-4 pb-3 border-b border-border">
          <h2 className="text-base font-semibold text-ink">Editar almacén</h2>
          <button onClick={onClose} className="text-sub hover:text-ink text-xs">
            cerrar ✕
          </button>
        </div>

        <div className="space-y-3">
          <Input
            label="Código"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="LIMA-CENTRO"
          />
          <Input
            label="Nombre"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <Input
            label="Dirección"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
          />
          <div className="grid grid-cols-2 gap-3">
            <Input
              label="Latitud"
              type="number"
              step="0.0001"
              value={lat}
              onChange={(e) => setLat(e.target.value)}
            />
            <Input
              label="Longitud"
              type="number"
              step="0.0001"
              value={lon}
              onChange={(e) => setLon(e.target.value)}
            />
          </div>
          <label className="flex items-center gap-2 text-sm text-ink mt-2">
            <input
              type="checkbox"
              checked={active}
              onChange={(e) => setActive(e.target.checked)}
              className="accent-primary"
            />
            <span>Activo</span>
          </label>
        </div>

        <div className="flex items-center justify-end gap-2 mt-5">
          <Button variant="ghost" size="sm" onClick={onClose}>
            Cancelar
          </Button>
          <Button variant="primary" size="sm" onClick={save}>
            Guardar
          </Button>
        </div>
      </div>
    </div>
  );
}
